<template>
    <el-dialog :title="title" :visible.sync="show" width="500px">
        <el-form :inline="true" :model="ruleForm" :rules="rules" ref="ruleForm" :label-width="80">
            <el-form-item label="大区名称" prop="large_name" v-show="true">
                <el-select v-model="ruleForm.large_name" @change="selectChange(ruleForm.large_name)">
                    <el-option v-for="item in regionList" :value="item.name" :key="item.id">{{ item.name }}
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="区域名称" prop="region_name">
                <el-input v-model="ruleForm.region_name" :autofocus="true" placeholder="区域名称" :maxlength="30"></el-input>
            </el-form-item>
        </el-form>
        <!-- </div> -->
        <span slot="footer" class="dialog-footer">
                            <el-button @click="show = false">取 消</el-button>
                            <el-button type="primary" @click="confirm('ruleForm')">确 定</el-button>
                          </span>
    </el-dialog>
</template>

<script>
import { isNumber_AZ_Chinese } from "@/plugins/common";
import apis from "@/config/apis";
import { Message } from "element-ui";
export default {
    data() {
        var region_name = (rule, value, callback) => {
            if (!isNumber_AZ_Chinese(value)) {
                return callback(new Error("请输入中文、字母或者数字，最大30个字符"));
            } else {
                return callback();
            }
        };
        return {
            show: false,
            title: '',
            regionList: [],
            ruleForm: {
                name: "",
                large_area_id: "",
                large_name:"",
                region_name:"",
                id: ""
            },
            rules: {
                region_name: [{
                    required: true,
                    validator: region_name,
                    trigger: "change"
                }],
                large_name: [{
                    required: true,
                    message: "请选择大区",
                    trigger: "change"
                }]
            }
        };
    },
    props: {},
    created() {
        this.getbizRegion();
    },
    methods: {
        selectChange(val) {
            this.regionList.forEach((value, index) => {
                if (value.name == val) {
                    this.ruleForm.large_area_id = this.regionList[index].id;
                    this.ruleForm.large_name = value.name;
                    this.ruleForm.region_name = '';
                }
            });
        },
        modifyshow(row) {
            this.show = true;
            this.title = row.title;
            this.ruleForm.large_name = row.large_name;
            this.ruleForm.region_name = row.name;
            this.ruleForm.id = row.id;
            this.ruleForm.large_area_id = row.id;
        },
        addshow(row) {
            this.show = true;
            this.ruleForm.large_name = "";
            this.ruleForm.region_name = "";
            this.title = row.title;
        },
        close() {
            this.$refs.ruleForm.resetFields();
            this.modalShow = false;
            this.ruleForm.large_name = "";
        },

        getbizRegion() {
            this.$axios.get(apis.region).then(res => {
                if (res.data.code == 200) {
                    this.regionList = res.data.data;
                }
            })
        },
        confirm(ruleForm) {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    if (this.ruleForm.id) {
                        let jsonData = {
                            id: this.ruleForm.large_area_id,
                            sb_name: this.ruleForm.region_name,
                        };
                        this.$axios.put(apis.updatearea, jsonData).then(res => {
                            if (res.data.code === 200) {
                                this.$emit("emitConfirm");
                                 this.$message({
                                  message: '修改成功',
                                  type: 'success'
                                 });
                                this.show = false;
                                this.$refs.ruleForm.resetFields();
                            } else {
                                this.show = true;
                                this.$message({
                                  message: res.data.msg,
                                  type: 'error'
                                 });
                            }
                        });
                    } else {
                        let jsonData = {
                            region_id: this.ruleForm.large_area_id,
                            sb_name: this.ruleForm.region_name,

                        }
                        this.$axios.post(apis.addarea, jsonData).then(res => {
                            if (res.data.code === 200) {
                                this.$emit("emitConfirm")
                                this.show = false;
                                 this.$message({
                                  message: '新增成功',
                                  type: 'success'
                                 });
                                this.$refs.ruleForm.resetFields();
                            } else {
                                 this.$message({
                                  message: res.data.msg,
                                  type: 'error'
                                 });
                            }
                        })
                    }
                }
            });
        }
    },
    watch: {}
};
</script>


<style lang="scss" scoped>
.el-input{
    width:250px;
}
.el-select{
    width:250px;
}
// @import url("../assets/css/common.scss");
</style>
